import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import JWTRegisterView from "./jwt-register-view";
import { m } from "framer-motion";

export default function RegisterPage() {
    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
            }}
        >
            <Grid
                container
                sx={{
                    width: "100%",
                    minHeight: "100vh",
                }}
            >
                {/* Left Section */}
                <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                        bgcolor: "#de4d1b",
                        color: "#fff",
                        display: { xs: "none", md: "flex" },
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        p: 4,
                    }}
                    component={m.div}
                    initial={{ opacity: 0, x: -40 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    {/* Logo Box */}
                    <Box
                               sx={{
                                 width: 320,
                                 height: 120,
                                 bgcolor: "#fff",
                                 borderRadius: 3,
                                 display: "flex",
                                 justifyContent: "center",
                                 alignItems: "center",
                                 mb: 4,
                                 boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                 overflow: "hidden",
                               }}
                             >
                               <Box
                                 component="img"
                                 src={`${process.env.PUBLIC_URL}/assets/logo.png`}
                                 alt="SiteSnap Logo"
                                 sx={{
                                   width: 240,
                                   height: 100,
                                   objectFit: "contain",
                                 }}
                               />
                             </Box>
                    
                     <Typography
                                variant="h3"
                                fontWeight="bold"
                                textAlign="center"
                                sx={{
                                  mb: 3,
                                  fontSize: { xs: '1.75rem', md: '2.5rem' },
                                }}
                              >
                               Join SiteSnap Today
                              </Typography>
                              <Typography
                                variant="body1"
                                textAlign="center"
                                sx={{
                                  opacity: 0.9,
                                  maxWidth: 380,
                                  lineHeight: 1.6,
                                }}
                              >
                                Create your account and start capturing, managing, and sharing your job site progress effortlessly.
                              </Typography>
                </Grid>

                {/* Right Section */}
                <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                        bgcolor: "#fff",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        p: 4,
                        minHeight: { xs: "100vh", md: "auto" },
                    }}
                    component={m.div}
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    <Box sx={{ width: "100%", maxWidth: 400 }}>
                        <JWTRegisterView />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}

